import React from 'react';
import { CreditCardIcon } from '@heroicons/react/24/solid';
import { DeleteFilled, DownloadOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import dayjs from 'dayjs';
import { dateFormat } from '@/configs/dateFormat';
interface IProps {
  key: string | number;
  url: string;
  name: string;
  date?: string;
  type?: string;
  onAction: (key: string | number) => void;
  readonly?: boolean;
  isDownload?: boolean;
}

const DocumentCard = ({
  url,
  name,
  onAction,
  key,
  readonly,
  type,
  isDownload,
  date,
}: IProps) => {
  // const isExternalUrl = url.startsWith('http') || url.startsWith('blob:');

  const handleDownload = (url: string, filename: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename); // Set the download attribute
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex bg-gray-100 rounded-md p-1 flex-row gap-2 justify-between items-center">
      <div className="flex items-center gap-2">
        <div className="bg-blue-200 p-2 rounded">
          <CreditCardIcon className="w-4 h-4" />
        </div>
        <div>
          <p className="font-bold truncate max-w-[320px]">{name}</p>
          <p className="text-gray-500">
            {dayjs(date || undefined).format(dateFormat)}
          </p>
        </div>
      </div>
      <div className="p-2 flex flex-none flex-row gap-2">
        <Tag className="font-bold px-2 py-1">{type?.toUpperCase()}</Tag>
        {!readonly && (
          <DeleteFilled
            className="text-red-600"
            onClick={() => onAction(key)}
          />
        )}
        {isDownload && (
          <DownloadOutlined onClick={() => handleDownload(url, name)} />
        )}
      </div>
    </div>
  );
};

export default DocumentCard;
